module.exports = __webpack_public_path__ + "img/dfwvga-banquet-2.f5e25650.png";